import { Box, CircularProgress, Typography } from '@mui/material'

interface LoadingOverlayProps {
  isLoading: boolean
  conversionInProgress: boolean
  totalImagesToLoad: number
  imagesLoadedCount: number
  message: string
}

export function LoadingOverlay({
  isLoading,
  conversionInProgress,
  totalImagesToLoad,
  imagesLoadedCount,
  message,
}: LoadingOverlayProps) {
  if (!isLoading && !conversionInProgress) {
    return null
  }

  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        zIndex: 10,
        color: 'white',
      }}
    >
      <CircularProgress color="primary" />
      {totalImagesToLoad > 0 ? (
        <Typography variant="body2" mt={2}>
          Loading images: {imagesLoadedCount} / {totalImagesToLoad}
        </Typography>
      ) : conversionInProgress ? (
        <Typography variant="body2" mt={2}>
          {message}
        </Typography>
      ) : null}
    </Box>
  )
}
